<script>
// Rótulo de grupo + slot com os itens. No modo recolhido vira um divisor fino.
export default {
  name: 'NavGroup',
  props: {
    title: { type: String, required: true },
    collapsed: { type: Boolean, default: false },
  },
}
</script>

<template>
  <div class="nav-group">
    <div v-if="collapsed" class="nav-group__divider" />
    <div v-else-if="title" class="nav-group__label">{{ title }}</div>
    <div class="nav-group__items">
      <slot />
    </div>
  </div>
</template>

<style lang="sass" scoped>
.nav-group
  &__label
    padding: 16px 16px 8px
    font-size: 10px
    font-weight: 700
    letter-spacing: 0.16em
    text-transform: uppercase
    color: rgba(var(--nav-fg-rgb, 255, 255, 255), 0.38)

  &__divider
    height: 1px
    margin: 14px 12px 8px
    background: rgba(var(--nav-fg-rgb, 255, 255, 255), 0.08)

  &__items
    display: flex
    flex-direction: column
    gap: 2px
</style>
